import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { authenticationService } from '../../services';


const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        logout();
    }, [])

    function logout() {
        document.cookie = 'HangFireCookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        authenticationService.logout();
        navigate('/');
    }

    return (
        <></>
    );
}

export default Logout;